import { createRootRoute, Outlet } from '@tanstack/react-router'
import { requireAuth } from '../lib/authGuard'
import { AppRoot } from '../AppRoot'
import { Breadcrumbs } from '@/components/Breadcrumbs'
import { PullToRefresh } from '@/components/PullToRefresh'
import { ScreenshotVersionHint } from '@/components/ScreenshotVersionHint'

export const Route = createRootRoute({
  beforeLoad: async ({ location }) => {
    await requireAuth(location.pathname)
  },
  component: () => (
    <AppRoot>
      <Breadcrumbs />
      <PullToRefresh>
        <Outlet />
      </PullToRefresh>
      <ScreenshotVersionHint />
    </AppRoot>
  ),
})
